export default [
  {
    value: "advance",
    text: "Guest Advance Confirmation"
  },
  { value: "final", text: "Guest Final Confirmation" },
  { value: "booking", text: "Owner Booking Notice" }
];
